// extracted by mini-css-extract-plugin
export var container = "_5h-0";
export var icon = "_5h-1";
export var text = "_5h-2";